import { ModalContainer } from "components/ui/display/ModalContainer"
import { Input } from "components/ui/inputs/Input";
import { useEffect, useState } from "react";


export const EditFolderNameModal = ({onSubmit, onDiscard, value=''}) => {

    const [folderName, setFolderName] = useState('');

    useEffect(() => {
        setFolderName(value)
    }, [value])

    return (
        <ModalContainer
            title="Endre mappenavn"
            description="Endre navn på inndelingen."
            submitText="Oppdater navn"
            discardText="Forkast"
            onSubmit={() => onSubmit(folderName)}
            onDiscard={onDiscard}
        >
            <Input
                title="Nytt mappenavn"
                placeholder="Mappenavn..."
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
            />
            
        </ModalContainer>
    )
}